import { Expose, plainToClass } from 'class-transformer';

import { Default } from '@lib/common/decorators';

import { SnAvatarConfig } from '../types/avatar-config.type';

export class SnAvatar {
  @Expose()
  public src: string;

  @Expose()
  public name: string;

  @Expose()
  public value: string;

  @Expose()
  public bgColor: string;

  @Expose()
  @Default(40)
  public size: number;

  @Expose()
  @Default(2)
  public initialsSize: number;

  @Expose()
  @Default(2.5)
  public textSizeRatio: number;

  public static fromConfig(data: SnAvatarConfig): SnAvatar {
    return plainToClass(SnAvatar, data, { strategy: 'excludeAll' });
  }

  constructor() {}
}
